import merge from 'lodash/merge';
import DomainResource from './DomainResource';
import CodeableConcept from './types/CodeableConcept';
import Money from './types/Money';
import Period from './types/Period';
import Quantity from './types/Quantity';
import Reference from './types/Reference';
import ValueX from './types/ValueX';

export default class ChargeItem extends DomainResource {
    static __className = 'ChargeItem';

    __objectStructure = {
        status: String, // planned | billable | not-billable | aborted | billed | entered-in-error | unknown
        code: CodeableConcept, // The procedure code being charged
        subject: Reference, // Reference to the Patient
        context: Reference, // Reference to the Encounter
        occurrence: ValueX, // occurrence[x] - DateTime, Period, or Timing
        performer: [Reference], // The provider(s) from the session
        quantity: Quantity, // Number of units
        priceOverride: Money, // The amount being charged
        service: [Reference], // Reference to the Procedure resource(s) - FHIR allows multiple
        supportingInformation: [Reference], // References to QuestionnaireResponse, ClaimResponse (for auth), etc.
        coverage: Reference, // Reference to the Coverage resource

        // Custom extensions
        perDiemBillingPeriod: Period, // Billing period this ChargeItem covers
        authorizationNumber: String, // Free-text authorization number (not linked to a ClaimResponse)
        claimType: String, // 'professional' or 'institutional' (defaults to professional)
        revCode: String, // Revenue code for institutional claims
        expectedAmount: Money, // Contracted (allowed) amount when the fee schedule bills the standard charge
    };

    __objectDefaults = {
        resourceType: 'ChargeItem',
    };

    constructor(constructJson, className = 'ChargeItem') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);

        // Handle performer structure conversion
        if (constructJson && constructJson.performer && Array.isArray(constructJson.performer)) {
            this.__performer = [];
            constructJson.performer.forEach((perf) => {
                if (perf.actor && perf.actor.id) {
                    const reference = new Reference(perf.actor);
                    this.__performer.push(reference);
                }
            });
        }
    }

    toJSON() {
        const json = merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));

        // Format performer structure for FHIR
        if (this.__performer && this.__performer.length > 0) {
            json.performer = this.__performer.map((actor) => ({
                actor: actor.toJSON(),
            }));
        } else {
            // Ensure performer is always an array, even if empty
            json.performer = [];
        }

        // Format supportingInformation structure for FHIR (omit when empty — Aidbox rejects empty arrays)
        if (this.__supportingInformation && this.__supportingInformation.length > 0) {
            json.supportingInformation = this.__supportingInformation.map((info) => info.toJSON());
        }

        return json;
    }
}
